import React from 'react'
import './css/app1.css'
import blog1 from './images/web-blog.jpg'
import blog2 from './images/seo-blog.jpg'
import blog3 from './images/social-bog.jpg'

export default function Blogs() {
  return (
   <>
   <div className="blogContainer">
   <div className="blogHeading">
    <h5>HAVE A EYE ON</h5>
   </div>
   <div className="blogMainheading">
    <h1>OUR LATEST BLOG</h1>
   </div>
   <div className="blogPara">
    <p>Explore our most recent blog posts for the latest insights and strategies in digital marketing. </p>
   </div>
   <div className="col-md-12">
    <div className="blogMain">
        <div className="col-md-3">
            <div className="blogContainArea">
                <div className="blogImage">
                    <img src={blog1} alt="" />
                </div>
                <div className="blogContainHeading">
                    <h3>Website Development</h3>
                </div>
                <div className="blogContainPara">
                    <p>In the modern era, having a strong digital presence is essential for any business aiming to thrive. With so many companies vying for attention online....</p>
                </div>
            </div>
        </div>
        <div className="col-md-3">
            <div className="blogContainArea">
                <div className="blogImage">
                    <img src={blog2} alt="" />
                </div>
                <div className="blogContainHeading">
                    <h3>SEO</h3>
                </div>
                <div className="blogContainPara">
                    <p>In the modern digital landscape, simply launching a website doesn’t guarantee success you need to ensure that it reaches the right audience.....</p>
                </div>
            </div>
        </div>
        <div className="col-md-3">
            <div className="blogContainArea">
                <div className="blogImage">
                    <img src={blog3} alt="" />
                </div>
                <div className="blogContainHeading">
                    <h3>Social Media Marketing</h3>
                </div>
                <div className="blogContainPara">
                    <p>In today’s fast-paced digital economy, building a brand online isn’t just an advantage it’s a necessity. With billions of users engaging....</p>
                </div>
            </div>
        </div>
        <div className="col-md-3">
            <div className="blogContainArea">
              <div className="col-md-12 blogpoints">
                <div className="blogpointMain">
                    <div className="col-md-4 pointarea">
                        <h1>1</h1>
                    </div>
                    <div className="col-md-8 pointContain">
                        <div className="pointContainHeading">
                            <h2> SEO Boost



</h2>
                        </div>
                        <div className="pointContainPara">
                            <p>Rank higher on Google and attract more organic, quality traffic.
                            </p>
                        </div>
                    </div>
                </div>
              </div>
              <div className="col-md-12 blogpoints">
                <div className="blogpointMain">
                    <div className="col-md-4 pointarea">
                        <h1>2</h1>
                    </div>
                    <div className="col-md-8 pointContain">
                        <div className="pointContainHeading">
                            <h2>Social Media</h2>
                        </div>
                        <div className="pointContainPara">
                            <p>Build brand awareness and engage your audience across social platforms.
                            </p>
                        </div>
                    </div>
                </div>
              </div>
              <div className="col-md-12 blogpoints">
                <div className="blogpointMain">
                    <div className="col-md-4 pointarea">
                        <h1>3</h1>
                    </div>
                    <div className="col-md-8 pointContain">
                        <div className="pointContainHeading">
                            <h2> PPC Ads</h2>
                        </div>
                        <div className="pointContainPara">
                            <p>Launch high-converting ads that drive instant, measurable business growth.
                            </p>
                        </div>
                    </div>
                </div>
              </div>
              <div className="col-md-12 blogpoints">
                <div className="blogpointMain">
                    <div className="col-md-4 pointarea">
                        <h1>4</h1>
                    </div>
                    <div className="col-md-8 pointContain">
                        <div className="pointContainHeading">
                            <h2>Web Design</h2>
                        </div>
                        <div className="pointContainPara">
                            <p>Get a fast, mobile-friendly website designed to convert visitors easily.</p>
                        </div>
                    </div>
                </div>
              </div>

            </div>
        </div>
    </div>

   </div>
   </div>
   </>
  )
}
